import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

document.querySelectorAll('.js-logo-slider').forEach((carousel) => {
  const slider = new Splide(carousel, {
    type: 'loop',
    arrows: false,
    pagination: false,
    gap: 70,
    autoWidth: true,
    drag: 'free',
    autoScroll: {
      speed: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
    breakpoints: {
      767: {
        gap: 35,
      },
    },
  });

  slider.mount({ AutoScroll });
});
